import angular from 'angular';

import { FavoritesController } from './favorites.controller';
import { FavoriteCreationController } from './favorite-creation.controller';
import { FavoritesService } from './favorites.service';


angular
  .module('favorites', [])
  .controller('FavoritesController', FavoritesController)
  .controller('FavoriteCreationController', FavoriteCreationController)
  .factory('FavoritesFactory', FavoritesService.FavoritesFactory)
